// extracted by mini-css-extract-plugin
export var moreButton = "index-module--moreButton--cA+Gh";